<template>
  <div class="principal py-gen">
    <div class="ui basic segment" v-show="bundle_setted">
      <div class="ui inverted dimmer" v-bind:class="{ active: is_loading }">
        <div class="ui text loader">{{ $t("loading") }}</div>
      </div>
      <div class="px-gen">
        <!-- <pre>{{ bundle }}</pre> -->
        <h3 class="ui header pheader fdinpro is-uppercase mb-0">
          {{ $t("bundle") }} {{ bundle.setup.name }}
        </h3>
        <h4 class="ui header fdinpro is-uppercase my-0 pl-3">
          {{ $t("start date") }}
          {{
            bundle.setup.start_date
              | formatDate(enterprise_setup.simple_date_format)
          }}
        </h4>
        <h4 class="ui header fdinpro is-uppercase my-0 pl-3">
          {{ $t("end date") }}
          {{
            bundle.setup.end_date
              | formatDate(enterprise_setup.simple_date_format)
          }}
        </h4>
        <h4 class="ui header fdinpro is-uppercase my-0 pl-3">
          {{ $t("materials") }}
          <a :href="bundle.setup.assets_link" target="_blank">{{
            bundle.setup.assets_link
          }}</a>
        </h4>
        <h4 class="ui header fdinpro is-uppercase my-0 pl-3">
          {{ $t("total de envios:") }} {{ bundle.nvb_code_requests.length }}
        </h4>
      </div>
      <div class="ui search py-15 px-gen">
        <div class="ui icon input search-by-date">
          <input
            class="prompt"
            type="text"
            placeholder="Fecha DD/MM/AAAA"
            v-model="filter_text"
          />
          <i class="search icon"></i>
        </div>
        <div class="results"></div>
      </div>
      <div class="table-codes- px-gen">
        <table class="ui very basic selectable striped table" ref="table">
          <thead>
            <tr>
              <th>{{ $t("date") }}</th>
              <th>{{ $t("serie") }}</th>
              <th>{{ $t("gpu") }}</th>
              <th>{{ $t("product") }}</th>
              <th>{{ $t("brand") }}</th>
              <th>{{ $t("bill") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(reqcode, reqcodeidx) in requests" :key="reqcodeidx">
              <td>
                {{
                  reqcode.create_date
                    | formatDate(enterprise_setup.simple_date_format)
                }}
              </td>
              <td>{{ reqcode.setup.card_or_notebook_serial }}</td>
              <td>{{ reqcode.nvb_graphic_card.setup.name }}</td>
              <td>{{ reqcode.setup.product_type }}</td>
              <td>{{ reqcode.nvb_brand.setup.name }}</td>
              <td>{{ reqcode.setup.bill_or_ticket_number }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- <pre>{{ bundle }}</pre> -->
    </div>
  </div>
</template>

<script>
import { local_api, error_toast, enterprise_setup } from "@/utils";
import filters from "@/filters";

export default {
  name: "NvidiaTicketStoreBundleDetail",
  filters: filters,
  data() {
    return {
      bundle: {
        setup: {},
        nvb_code_requests: [],
      },
      is_loading: false,
      filter_text: "",
      bundle_setted: undefined,
    };
  },
  methods: {
    setBundle(bundle) {
      let vm = this;
      vm.bundle_setted = bundle;
      vm.is_loading = true;
      local_api(vm, "post", "/nvidia_ticket/store/do-get-bundle-info", {
        u: bundle.bundle_id,
      })
        .then(function(r) {
          vm.bundle = r;
        })
        .catch(function(err) {
          error_toast(err);
        })
        .finally(() => {
          vm.is_loading = false;
        });
    },
    refresh() {
      let vm = this;
      if (vm.bundle_setted) {
        vm.setBundle(vm.bundle_setted);
      }
    },
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
    requests() {
      let vm = this;
      if (vm.bundle && vm.bundle.nvb_code_requests) {
        if (vm.filter_text) {
          return vm.bundle.nvb_code_requests.filter((r) => {
            let toSearch = vm.filter_text.toLowerCase();
            return (
              r.create_date.toLowerCase().includes(toSearch) ||
              r.setup.bill_or_ticket_number.toLowerCase().includes(toSearch) ||
              r.setup.card_or_notebook_serial
                .toLowerCase()
                .includes(toSearch) ||
              r.setup.customer_email.toLowerCase().includes(toSearch) ||
              r.setup.customer_name.toLowerCase().includes(toSearch) ||
              r.setup.product_type.toLowerCase().includes(toSearch) ||
              r.nvb_brand.setup.name.toLowerCase().includes(toSearch) ||
              r.nvb_graphic_card.setup.name.toLowerCase().includes(toSearch)
            );
          });
        } else {
          return vm.bundle.nvb_code_requests;
        }
      } else {
        return [];
      }
    },
  },
};
</script>

<style scoped>
/* @import url("https://nworkforce.com/librerias/css/fonts/fonts.css"); */

.principal {
  flex: 54%;
  background-color: white;
  z-index: 4;
  box-shadow: 0 0.5em 1em -0.125em rgb(10 10 10 / 10%),
    0 0 0 1px rgb(10 10 10 / 2%);
}
.py-gen {
  padding-top: 5.5rem;
  padding-bottom: 0;
}
.px-gen {
  padding-right: 2rem !important;
  padding-left: 2rem !important;
} /*gen controla padding de los 3 modulos principales*/
.fdinpro {
  font-family: "DINPro" !important;
}
.pheader {
  font-weight: 300;
  font-size: 1.5rem !important;
  padding: 0.5rem 0 !important;
}
.is-uppercase {
  text-transform: uppercase !important;
}
.mb-0 {
  margin-bottom: 0 !important;
}
.my-0 {
  margin-bottom: 0 !important;
  margin-top: 0 !important;
}
.pl-3 {
  padding-left: 3rem !important;
}
.py-15 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.search-by-date {
  width: 100%;
}
.table-codes- {
  font-size: 90% !important;
  overflow-y: auto;
  height: 62vh;
}
.table-codes- table thead tr th {
  padding-bottom: 0.25rem !important;
}
.table-codes- table tbody tr td {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}
</style>
